
        require('./index.scss');
        'use strict';

// var $$swiper = require('lib/swiper.js');
var $ = window.$;
var $mod = $('.module-ad-banner-r');
var _ = window._;

var scroll = {
    init: function init() {
        var _ = window._;
        var $ = window.$;
        var $cityFooter = $mod.parent().find('.module-city-friend-link');
        var fixLimit = $cityFooter.offset().top + $cityFooter.height() || 4600;
        var scrollFn = _.throttle(function () {
            fixLimit = $cityFooter.offset().top + $cityFooter.height() || 4600;
            var scrollTop = $(window).scrollTop();
            var footTop = $mod.parents().find('#doc').find('#ft-block').offset().top;
            if (scrollTop >= fixLimit) {
                if (scrollTop < footTop - $mod.height() - 20) {
                    $mod.removeClass('fix-bottom');
                    $mod.addClass('fix-right');
                }
                if ($mod.offset().top + $mod.height() + 20 > footTop) {
                    var feedHeight = $mod.parents('#bd-row').height();
                    $mod.parent().height(feedHeight);
                    $mod.removeClass('fix-right');
                    $mod.addClass('fix-bottom');
                }
            } else {
                $mod.removeClass('fix-right');
                $mod.removeClass('fix-bottom');
            }
        }, 200);

        $(window).on('scroll', scrollFn);
    }
};

var bannerSw = {
    slides: $mod.find('.swiper-slide'),
    wraper: $mod.find('.swiper-wrapper'),
    pagination: $mod.find('.swiper-pagination-bullet'),
    timeCtl: 0,
    slideLen: $mod.find('.swiper-slide').length,
    init: function init() {
        this.slides.eq(0).show().addClass('active');
        this.start();
        this.bind();
        if (this.pagination.length <= 1) {
            $mod.find('.swiper-pagination').hide();
        }
    },
    start: function start() {
        var that = this;
        that.timeCtl = setInterval(function () {
            var activeSlide = that.wraper.find('.swiper-slide.active');
            var activeIndex = activeSlide.index();
            var nextIndex = activeIndex + 1;
            if (nextIndex >= that.slideLen) {
                nextIndex = 0;
            }
            that.changeSlide(nextIndex);
        }, 3000);
    },
    changeSlide: function changeSlide(index) {
        this.slides.eq(index).show().addClass('active').siblings().hide().removeClass('active');
        this.pagination.eq(index).addClass('swiper-pagination-bullet-active').siblings().removeClass('swiper-pagination-bullet-active');

        window.FCAdLog && window.FCAdLog.elPv($mod.find('.banner-link').eq(index));
    },
    bind: function bind() {
        var that = this;
        this.pagination.on('mouseenter', function () {
            that.changeSlide($(this).index());
        });
    }
};
var _module = {
    init: function init() {
        if ($mod.length) {
            bannerSw.init();
            scroll.init();
        }
    }
};

_module.init();;
    


// WEBPACK FOOTER //
// ./src/module/ad/ad-banner-r/index.js